import { useEffect } from "react";
import { isEditableTarget } from "@/lib/keyboard";
import type { PaneSide } from "./types";

export interface TradingKeyboardOptions {
  focusedPane: PaneSide;
  onFocusPane: (pane: PaneSide) => void;
  onFocusPickerSearch: (pane: PaneSide) => void;
  onSwap: () => void;
  onToggleFullscreen: () => void;
  onMoveSelection: (direction: 1 | -1) => void;
  onToggleSelected: () => void;
  onEscape: () => void;
  onMute: () => void;
  onRefresh: () => void;
  onShowHelp: () => void;
}

export function useTradingKeyboard({
  focusedPane,
  onEscape,
  onFocusPane,
  onFocusPickerSearch,
  onMoveSelection,
  onMute,
  onRefresh,
  onShowHelp,
  onSwap,
  onToggleFullscreen,
  onToggleSelected,
}: TradingKeyboardOptions) {
  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      const isEscape = event.key === "Escape" || event.key === "Esc";
      if (isEditableTarget(event.target) && !isEscape) return;

      switch (event.key) {
        case "1":
          event.preventDefault();
          onFocusPane("left");
          break;
        case "2":
          event.preventDefault();
          onFocusPane("right");
          break;
        case "/":
          event.preventDefault();
          onFocusPickerSearch(focusedPane);
          break;
        case "s":
          event.preventDefault();
          onSwap();
          break;
        case "f":
          event.preventDefault();
          onToggleFullscreen();
          break;
        case "j":
          event.preventDefault();
          onMoveSelection(1);
          break;
        case "k":
          event.preventDefault();
          onMoveSelection(-1);
          break;
        case "Enter":
          event.preventDefault();
          onToggleSelected();
          break;
        case "Escape":
        case "Esc":
          event.preventDefault();
          onEscape();
          break;
        case "m":
          event.preventDefault();
          onMute();
          break;
        case "r":
          event.preventDefault();
          onRefresh();
          break;
        case "?":
          event.preventDefault();
          onShowHelp();
          break;
      }
    }

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [
    focusedPane,
    onEscape,
    onFocusPane,
    onFocusPickerSearch,
    onMoveSelection,
    onMute,
    onRefresh,
    onShowHelp,
    onSwap,
    onToggleFullscreen,
    onToggleSelected,
  ]);
}
